import React from "react";
import { useMediaQuery } from "@mui/material";
import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";
import TabletLayout from "./TabletLayout";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery((theme: any) =>
    theme.breakpoints.between("sm", "md")
  );
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up("md"));

  return (
    <>
      {isMobile && <MobileLayout>{children}</MobileLayout>}
      {isTablet && <TabletLayout>{children}</TabletLayout>}
      {isDesktop && <DesktopLayout>{children}</DesktopLayout>}
    </>
  );
};
